/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleValuationReportData
 */
export interface VehicleValuationReportData {
    /**
     * 
     * @type {string}
     * @memberof VehicleValuationReportData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleValuationReportData
     */
    vehicleReportId?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleValuationReportData
     */
    date?: Date;
    /**
     * 
     * @type {number}
     * @memberof VehicleValuationReportData
     */
    vehicleValue?: number;
}

export function VehicleValuationReportDataFromJSON(json: any): VehicleValuationReportData {
    return VehicleValuationReportDataFromJSONTyped(json, false);
}

export function VehicleValuationReportDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleValuationReportData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'vehicleReportId': !exists(json, 'vehicleReportId') ? undefined : json['vehicleReportId'],
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'vehicleValue': !exists(json, 'vehicleValue') ? undefined : json['vehicleValue'],
    };
}

export function VehicleValuationReportDataToJSON(value?: VehicleValuationReportData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'vehicleReportId': value.vehicleReportId,
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'vehicleValue': value.vehicleValue,
    };
}


